<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex md12 class="d-flex align-center">
        <div class="text-h5 mt-4">Provider Transactions (DF)</div>
        <v-icon class="ml-4 mt-4" large color="primary" @click="addTransactionClick">mdi-plus-circle</v-icon>
      </v-flex>
      <v-flex md2 class="mt-2">
        <v-select v-model="status" :items="statusOptions" @change="getDataFromApi" label="Approval Status"></v-select>
      </v-flex>
      <v-flex md4 class="mt-2 ml-2">
        <v-autocomplete
          clearable
          v-model="providerId"
          :items="providerOptions"
          @change="getDataFromApi"
          label="Provider Name"
        ></v-autocomplete>
      </v-flex>
      <v-flex md12 class="mt-4 d-flex align-center">
        <v-data-table
          :headers="headers"
          :items="transactions"
          :options.sync="options"
          :server-items-length="totalTransaction"
          :loading="loading"
          class="elevation-1 full-width"
        >
          <template v-slot:item.approval_status="{ item }">
            <v-chip :color="getStatusColor(item.approval_status)" dark>
              {{ item.approval_status }}
            </v-chip>
          </template>
          <template v-slot:item.associated_type="{ item }">
            <v-chip :color="getTypeColor(item.associated_type)" dark>
              {{ item.associated_type }}
            </v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="d-flex flex-row">
              <!-- 
                now, allow all status can fix transaction
                :disabled="item.approval_status !== 'complained'" 
               -->
              <v-icon small class="mr-2" color="blue" @click="clickShowFixComplainedDialog(item)"> mdi-tools </v-icon>
              <v-icon
                small
                class="mr-2"
                color="red"
                :disabled="item.associated_type == 'Appointment'"
                @click="deleteTransactionClick(item)"
              >
                mdi-delete
              </v-icon>
            </div>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-dialog v-model="isShowFixComplainedDialog" v-if="toFixTransaction" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Fix Complained Transaction</v-card-title>
        <v-card-text>
          <div>Transaction ID: {{ toFixTransaction.id }}</div>
          <div>Provider: {{ toFixTransaction.provider_name }}</div>
          <div>Provider ID: {{ toFixTransaction.provider_profile_id }}</div>
          <div>Appointment ID: {{ toFixTransaction.associated_id }}</div>
          <div>Description: {{ toFixTransaction.description }}</div>
          <div>Comment: {{ toFixTransaction.comment }}</div>
          <div>Amount: {{ formatNumber(toFixTransaction.amount) }}</div>
          <div>Complaint: {{ toFixTransaction.complaint_draft }}</div>
          <v-text-field
            class="mt-4"
            label="New amount (THB)"
            type="number"
            outlined
            v-model="dialogNewAmount"
            :hide-details="true"
          ></v-text-field>
          <v-textarea
            class="mt-3"
            label="Message to provider"
            rows="3"
            outlined
            v-model="dialogMessageToProvider"
            :hide-details="true"
          ></v-textarea>
          <div class="mt-4">
            When click <b>Send</b>, system will change transaction amount to the new amount, change status to
            <b>pending</b> and notify the provider to re-check the transaction.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="isShowFixComplainedDialog = false">Cancel</v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="submitFixComplainedTransaction"
            :disabled="!dialogNewAmount || !dialogMessageToProvider"
          >
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isShowNewTransaction" max-width="500px">
      <v-card>
        <v-card-title class="text-h5 mb-4">Create a new provider gain</v-card-title>
        <v-card-text>
          <!-- here -->
          <v-autocomplete
            v-model="newTransactionProviderId"
            :items="newTransactionProviderOptions"
            label="Provider Name"
            class="mb-4"
            outlined
            :hide-details="true"
          ></v-autocomplete>
          <v-select
            v-model="newTransactionServiceType"
            :items="newTransactionServiceTypeOptions"
            label="Service Type"
            class="mb-4"
            outlined
            :hide-details="true"
            @change="serviceTypeChanged"
          ></v-select>
          <v-text-field
            class="mb-4"
            label="Amount (THB)"
            type="number"
            outlined
            v-model="newTransactionAmount"
            :hide-details="true"
          ></v-text-field>
          <v-select
            class="mb-4"
            v-model="newTransactionChannel"
            :items="newTransactionChannelOptions"
            label="Channel"
            outlined
            :hide-details="true"
          ></v-select>
          <v-select
            class="mb-4"
            v-model="newTransactionTaxType"
            :items="newTransactionTaxTypeOptions"
            label="Tax Type"
            outlined
            :hide-details="true"
          ></v-select>
          <v-select
            class="mb-4"
            v-model="newTransactionPeakCode"
            :items="newTransactionPeakCodeOptions"
            label="Peak Code"
            outlined
            :hide-details="true"
          ></v-select>
          <div>
            <div class="text-subtitle-2">Service At</div>
            <v-text-field
              v-model="newTransactionServiceAt"
              label="Date"
              type="text"
              readonly
              outlined
              class="mb-4"
              :hide-details="true"
              @click="openDatePicker('service-at')"
            ></v-text-field>
          </div>
          <div>
            <div class="text-subtitle-2">Approved At</div>
            <div class="d-flex flex-row">
              <v-text-field
                v-model="newTransactionApprovedAtDate"
                label="Date"
                type="text"
                readonly
                outlined
                class="mb-4 mr-2"
                :hide-details="true"
                @click="openDatePicker('approved-at')"
              ></v-text-field>
              <v-text-field
                v-model="newTransactionApprovedAtTime"
                label="Time"
                type="text"
                readonly
                outlined
                class="mb-4"
                :hide-details="true"
                @click="openTimePicker('approved-at')"
              ></v-text-field>
            </div>
          </div>
          <div class="mt-4">
            When click <b>CREATE</b>, system will send a Line notification message to the provider.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="isShowNewTransaction = false">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="createNewTransaction" :disabled="!canCreateNewTransaction">
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isShowDeleteTransaction" max-width="500px">
      <v-card>
        <v-card-title class="text-h5 mb-4">
          <v-icon color="red" class="mr-2">mdi-delete</v-icon>
          Delete Transaction
        </v-card-title>
        <v-card-text>
          <div class="ml-1">Are you sure you want to delete this transaction?</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="gray darken-1" text @click="isShowDeleteTransaction = false">Cancel</v-btn>
          <v-btn color="red darken-1" text @click="deleteTransaction"> Delete </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog scrollable v-model="isDatePickerOpen" width="400px">
      <v-date-picker
        v-if="isDatePickerOpen"
        v-model="selectedDate"
        color="primary"
        @change="closeAndSetDatePickerValue"
        :allowed-dates="allowdDates"
      ></v-date-picker>
    </v-dialog>
    <v-dialog scrollable v-model="isTimePickerOpen" width="400px">
      <v-time-picker
        v-if="isTimePickerOpen"
        v-model="selectedTime"
        color="primary"
        @change="closeAndSetTimePickerValue"
        format="24hr"
      ></v-time-picker>
    </v-dialog>
  </v-container>
</template>

<script>
import { Vue } from 'vue-property-decorator';
import store from '../../../store';
import axios from 'axios';
import dateUtil from '../../../utils/dateTime';
import stringUtil from '../../../utils/stringUtil';
import provider from '../../../services/providerProfiles';
import moment from 'moment';

export default Vue.extend({
  store,
  data() {
    return {
      headers: [
        {
          text: 'ID',
          align: 'start',
          sortable: true,
          value: 'id',
        },
        {
          text: 'Provider',
          align: 'start',
          sortable: false,
          value: 'provider_name',
        },
        {
          text: 'Service Type',
          align: 'start',
          sortable: false,
          value: 'associated_type',
        },
        {
          text: 'Service ID',
          align: 'start',
          sortable: false,
          value: 'associated_id',
        },
        {
          text: 'Approval Status',
          align: 'start',
          sortable: false,
          value: 'approval_status',
        },
        {
          text: 'Amount (THB)',
          align: 'start',
          sortable: false,
          value: 'amount_formatted',
        },
        {
          text: 'Complaint',
          align: 'start',
          sortable: false,
          value: 'complaint_draft',
        },
        {
          text: 'Description',
          align: 'start',
          sortable: false,
          value: 'description',
        },
        {
          text: 'Comment',
          align: 'start',
          sortable: false,
          value: 'comment',
        },
        {
          text: 'Channel',
          align: 'start',
          sortable: false,
          value: 'channel',
        },
        {
          text: 'Tax Type',
          align: 'start',
          sortable: false,
          value: 'tax_type',
        },
        {
          text: 'Peak Code',
          align: 'start',
          sortable: false,
          value: 'peak_code',
        },
        {
          text: 'Approved At',
          align: 'start',
          sortable: true,
          value: 'approved_at',
        },
        {
          text: 'Service At',
          align: 'start',
          sortable: true,
          value: 'service_at',
        },
        {
          text: 'Actions',
          align: 'start',
          sortable: false,
          value: 'actions',
        },
      ],
      transactions: [],
      totalTransaction: 100,
      options: {
        sortBy: ['id'],
        sortDesc: [true],
      },
      loading: false,
      status: null,
      providerId: null,
      providerOptions: [{ text: 'All', value: null }],
      statusOptions: [
        { text: 'All', value: null },
        { text: 'Approved', value: 'approved' },
        { text: 'Pending', value: 'pending' },
        { text: 'Complained', value: 'complained' },
      ],
      isShowFixComplainedDialog: false,
      toFixTransaction: null,
      dialogNewAmount: null,
      dialogMessageToProvider: null,
      isShowNewTransaction: false,
      newTransactionProviderOptions: [],
      newTransactionProviderId: null,
      newTransactionAmount: null,
      newTransactionServiceType: null,
      newTransactionChannel: null,
      newTransactionTaxType: null,
      newTransactionPeakCode: null,
      newTransactionServiceAt: null,
      newTransactionServiceTypeOptions: [
        { text: 'Interview', value: 'interview' },
        { text: 'Workshop', value: 'workshop' },
        { text: 'Onsite Counseling', value: 'onsite counseling' },
        { text: 'Seminar', value: 'seminar' },
        { text: 'Travel Fee', value: 'travel fee' },
        { text: 'DTMS Commission', value: 'dtms commission' },
        { text: 'BWC (Guarantee)', value: 'bwc (guarantee)' },
        { text: 'Procedure', value: 'procedure' },
      ],
      newTransactionChannelOptions: [
        { text: 'Application', value: 'app' },
        { text: 'Clinic', value: 'clinic' },
      ],
      newTransactionTaxTypeOptions: [
        { text: 'DF40(2)', value: 'DF40(2)' },
        { text: 'DF40(6)', value: 'DF40(6)' },
      ],
      newTransactionPeakCodeOptions: [
        { text: '#510112', value: '#510112' },
        { text: '#530118', value: '#530118' },
        { text: '#510111', value: '#510111' },
        { text: '#530114', value: '#530114' },
        { text: '#510121', value: '#510121' },
        { text: '#510123', value: '#510123' },
        { text: '#520216', value: '#520216' },
      ],
      newTransactionApprovedAtDate: null,
      newTransactionApprovedAtTime: null,
      isShowDeleteTransaction: false,
      toDeleteTransactionId: null,
      isDatePickerOpen: false,
      isTimePickerOpen: false,
      dataModelToUpdate: null,
      selectedDate: null,
      selectedTime: null,
    };
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
  },
  async mounted() {
    await this.fetchProviderOption();
  },
  computed: {
    canCreateNewTransaction() {
      return (
        this.newTransactionProviderId &&
        this.newTransactionAmount &&
        this.newTransactionAmount >= 0 &&
        this.newTransactionServiceType &&
        this.newTransactionChannel &&
        this.newTransactionTaxType &&
        this.newTransactionPeakCode &&
        this.newTransactionServiceAt &&
        this.newTransactionApprovedAtDate &&
        this.newTransactionApprovedAtTime
      );
    },
  },
  methods: {
    async getDataFromApi() {
      const { itemsPerPage, page, sortBy, sortDesc } = this.options;

      this.loading = true;

      try {
        const { data } = await axios.get(`${process.env.VUE_APP_API_ADMIN_LOCATION}provider-transactions`, {
          params: {
            status: this.status,
            provider_id: this.providerId,
            per_page: itemsPerPage,
            page: page,
            order: sortBy.length ? sortBy[0] : 'id',
            sort: sortDesc.length && !sortDesc[0] ? 'asc' : 'desc',
          },
        });
        const transactions = data.data.map((transaction) => ({
          id: transaction.id,
          provider_name: `${transaction.provider.prefix.th} ${transaction.provider.firstname.th} ${transaction.provider.lastname.th}`,
          provider_profile_id: transaction.provider_profile_id,
          associated_type: stringUtil.capitalize((transaction.associated_type || '').replace('App\\', '')),
          associated_id: transaction.associated_id,
          approval_status: transaction.status,
          amount_formatted: this.formatNumber(transaction.amount / 100),
          amount: transaction.amount / 100,
          complaint_draft: transaction.complaint_draft || '-',
          description: transaction.description || '-',
          comment: transaction.comment || '-',
          channel: transaction.details.channel || '-',
          tax_type: transaction.details.tax_type || '-',
          peak_code: transaction.details.peak_code || '-',
          service_at: (transaction.details.service_at || '-').split(' ')[0],
          approved_at: transaction.approved_at
            ? dateUtil.formateDateTimeForDisplay(transaction.approved_at, 'DD MMM YYYY HH:mm')
            : '-',
          created_at: dateUtil.formateDateTimeForDisplay(transaction.created_at, 'DD MMM YYYY HH:mm'),
        }));

        this.transactions = transactions;
        this.totalTransaction = data.pagination.total;
      } catch (error) {
        console.error('Error fetching provider transactions:', error);
      } finally {
        this.loading = false;
      }
    },
    addTransactionClick() {
      this.isShowNewTransaction = true;
      this.clearNewTransactionForm();
    },
    deleteTransactionClick(item) {
      this.toDeleteTransactionId = item.id;
      this.isShowDeleteTransaction = true;
    },
    getStatusColor(status) {
      switch (status) {
        case 'approved':
          return 'green';
        case 'complained':
          return 'red';
        default:
          return 'grey darken-2';
      }
    },
    getTypeColor(type) {
      switch (type) {
        case 'Appointment':
          return 'blue-grey lighten-2';
        default:
          return 'purple';
      }
    },
    clickShowFixComplainedDialog(transaction) {
      // now, allow all status can fix transaction
      // if (transaction.approval_status !== 'complained') {
      //   return;
      // }
      this.isShowFixComplainedDialog = true;
      this.toFixTransaction = transaction;
      this.dialogNewAmount = transaction.amount;
      this.dialogMessageToProvider = '';
    },
    async submitFixComplainedTransaction() {
      console.log(
        'submitFixComplainedTransaction',
        this.toFixTransaction.id,
        this.dialogNewAmount,
        this.dialogMessageToProvider
      );
      await axios.patch(
        `${process.env.VUE_APP_API_ADMIN_LOCATION}provider-transactions/complaint/${this.toFixTransaction.id}/fix`,
        {
          amount: this.dialogNewAmount,
          message: this.dialogMessageToProvider,
        }
      );
      this.isShowFixComplainedDialog = false;
      this.getDataFromApi();
    },
    formatNumber(n) {
      return new Intl.NumberFormat('th-TH').format(n);
    },
    async fetchProviderOption() {
      try {
        const providers = await provider.all({ archived: false, per_page: 500, order: 'id', sort: 'asc' });
        const options = providers.data.map((p) => ({
          text: `${p.id}: ${p.prefix.th} ${p.firstname.th} ${p.lastname.th}`,
          value: p.id,
        }));
        this.providerOptions = [{ text: 'All', value: null }, ...options];
        this.newTransactionProviderOptions = options;
      } catch (error) {
        console.error('Error fetching provider options:', error);
      }
    },
    clearNewTransactionForm() {
      this.newTransactionProviderId = null;
      this.newTransactionAmount = null;
      this.newTransactionServiceType = null;
      this.newTransactionChannel = null;
      this.newTransactionTaxType = null;
      this.newTransactionPeakCode = null;
      this.newTransactionServiceAt = null;
      this.newTransactionApprovedAtDate = null;
      this.newTransactionApprovedAtTime = null;
    },
    async createNewTransaction() {
      try {
        const approvedAt = `${this.newTransactionApprovedAtDate} ${this.newTransactionApprovedAtTime}`;
        await axios.post(
          `${process.env.VUE_APP_API_ADMIN_LOCATION}providers/${this.newTransactionProviderId}/transactions`,
          {
            amount: parseInt(this.newTransactionAmount),
            service_type: this.newTransactionServiceType,
            channel: this.newTransactionChannel,
            tax_type: this.newTransactionTaxType,
            peak_code: this.newTransactionPeakCode,
            service_at: `${this.newTransactionServiceAt} 00:00:00`,
            approved_at: moment(approvedAt).utc().format('YYYY-MM-DD HH:mm:ss'),
          }
        );
        this.isShowNewTransaction = false;
        this.clearNewTransactionForm();
        await this.getDataFromApi();
      } catch (error) {
        console.error('Error creating new transaction:', error);
      }
    },
    async deleteTransaction() {
      try {
        await axios.delete(
          `${process.env.VUE_APP_API_ADMIN_LOCATION}provider-transactions/${this.toDeleteTransactionId}`
        );
        this.isShowDeleteTransaction = false;
        await this.getDataFromApi();
      } catch (error) {
        console.error('Error deleting transaction:', error);
      }
    },
    serviceTypeChanged() {
      if (this.newTransactionServiceType === 'interview') {
        this.newTransactionTaxType = 'DF40(6)';
        this.newTransactionPeakCode = '#530114';
        this.newTransactionChannel = null;
      } else if (this.newTransactionServiceType === 'bwc (guarantee)') {
        this.newTransactionTaxType = 'DF40(2)';
        this.newTransactionPeakCode = '#530118';
        this.newTransactionChannel = 'clinic';
      } else if (this.newTransactionServiceType === 'dtms commission') {
        this.newTransactionTaxType = 'DF40(6)';
        this.newTransactionPeakCode = '#510112';
        this.newTransactionChannel = 'clinic';
      } else if (this.newTransactionServiceType === 'onsite counseling') {
        this.newTransactionTaxType = 'DF40(6)';
        this.newTransactionPeakCode = '#510123';
        this.newTransactionChannel = 'app';
      } else if (this.newTransactionServiceType === 'procedure') {
        this.newTransactionTaxType = 'DF40(6)';
        this.newTransactionPeakCode = '#510111';
        this.newTransactionChannel = 'clinic';
      } else if (this.newTransactionServiceType === 'seminar') {
        this.newTransactionTaxType = 'DF40(6)';
        this.newTransactionPeakCode = '#510121';
        this.newTransactionChannel = null;
      } else if (this.newTransactionServiceType === 'travel fee') {
        this.newTransactionTaxType = 'DF40(2)';
        this.newTransactionPeakCode = '#530118';
        this.newTransactionChannel = 'clinic';
      } else if (this.newTransactionServiceType === 'workshop') {
        this.newTransactionTaxType = 'DF40(6)';
        this.newTransactionPeakCode = '#510121';
        this.newTransactionChannel = null;
      } else {
        this.newTransactionChannel = null;
        this.newTransactionTaxType = null;
        this.newTransactionPeakCode = null;
      }
    },
    openDatePicker(targetModel) {
      this.dataModelToUpdate = targetModel;
      this.isDatePickerOpen = true;
    },
    closeAndSetDatePickerValue() {
      this.isDatePickerOpen = false;
      if (this.dataModelToUpdate === 'service-at' && this.selectedDate) {
        this.newTransactionServiceAt = this.selectedDate;
      } else if (this.dataModelToUpdate === 'approved-at' && this.selectedDate) {
        this.newTransactionApprovedAtDate = this.selectedDate;
      }
    },
    openTimePicker(targetModel) {
      this.dataModelToUpdate = targetModel;
      this.isTimePickerOpen = true;
    },
    closeAndSetTimePickerValue() {
      this.isTimePickerOpen = false;
      if (this.dataModelToUpdate === 'approved-at' && this.selectedTime) {
        this.newTransactionApprovedAtTime = this.selectedTime;
      }
    },
    allowdDates() {
      if (this.dataModelToUpdate !== 'approved-at') {
        return true;
      }
      /* 
        we disable date restriction for approved at date selection field
        with this ticket https://oocahq.atlassian.net/browse/BUS-4789
      */
      // const today = moment();
      // const selected = moment(date);
      // return (
      //   selected.isSameOrBefore(today, 'day') && selected.isSameOrAfter(today.clone().subtract(1, 'months'), 'day')
      // );
      return true;
    },
  },
});
</script>
